module.exports = __webpack_public_path__ + "img/2026-05-03c_1.1fa5b04e.jpg";